import { FC } from 'react';

import { Contact } from 'lucide-react';

import {
    STATUS_MESSAGE_ROW_CLASS,
    StatusNoticeTone,
} from './orderStatusNoticeTone';

interface Props {
    telegramUsername?: string | null;
    message: string;
    tone: StatusNoticeTone;
}

export const OrderTelegramContactNotice: FC<Props> = ({
    telegramUsername,
    message,
    tone,
}) => {
    if (!telegramUsername) {
        return null;
    }

    return (
        <div className={`mt-3 rounded-md border p-3 ${tone.container}`}>
            <div className={STATUS_MESSAGE_ROW_CLASS}>
                <Contact className={tone.text} />
                <span className={`font-medium ${tone.text}`}>{message} </span>
                <a
                    href={`https://t.me/${telegramUsername.replace('@', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`font-semibold hover:underline ${tone.link}`}
                >
                    {telegramUsername}
                </a>
            </div>
        </div>
    );
};
